import React, {useState, useEffect} from 'react';
import {AppRoutes} from "../../../Router";
import {useNavigate} from 'react-router-dom';
import {Visibility} from '@mui/icons-material';
import './sd.scss';
import './pagination.scss';
import {VscChevronLeft, VscChevronRight, VscChevronDown} from "react-icons/vsc";

const solicTableLabels = {
    creditStatus: "Estado cr\u00e9dito",
    creditLine: "L\u00ednea de cr\u00e9dito",
    empty: "No hay solicitudes para mostrar",
    rowsPerPage: "Filas por p\u00e1gina:",
    detail: "Ver detalle",
};

const cellValue = (value) => value || "-";
const requestDate = (value) => value ? value.split("-00.")[0] : "-";
const StatusContent = ({value}) => (
    <>
        <span className="statusDot" style={{background: "#017D73"}}></span>
        <span className="statusText">{cellValue(value)}</span>
    </>
);

const SolicItem = ({info}) => {
    const navigate = useNavigate();
    const ira = (id, indentifi, tipoidenti) => {
        navigate(AppRoutes.DETALLE_DEL_CREDITO + "?" + id + "-" + indentifi + "-" + tipoidenti, {replace: true});
    }
    return (
        <>
            <ul>
                <li className="listItem firstItem">{cellValue(info.info.Pws_Nombres)}</li>
                <li className="listItem mutedItem">{cellValue(info.info.Pws_ciudad)}</li>
                <li className="listItem statusItem"><StatusContent value={info.info.Pws_Estado_Firma}/></li>
                <li className="listItem statusItem"><StatusContent value={info.info.Pws_Estado_credito}/></li>
                <li className="listItem amountItem">{cellValue(info.info.Pws_Val_finan)}</li>
                <li className="listItem mutedItem">{cellValue(info.info.Pws_Lincre)}</li>
                <li className="listItem dateItem">{requestDate(info.info.Pws_fec_solicitud)}</li>
                <li className="listItem actionsItem">
                    <button
                        type="button"
                        className="detailButton"
                        aria-label={solicTableLabels.detail}
                        data-id={info.info.Pws_num_solicitud}
                        data-ids={info.info.Pws_Identificacion}
                        data-idss={info.info.Pws_Tip_Identificacion}
                        onClick={(event) => {
                            ira(event.currentTarget.dataset.id, event.currentTarget.dataset.ids, event.currentTarget.dataset.idss)
                        }}
                    >
                        <Visibility/>
                    </button>
                </li>
            </ul>
        </>
    )
}

export const SolicTable = (valor) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [tableItems, setTableItems] = useState([]);
    const [currentItems, setCurrentItems] = useState([]);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [ipp, setIpp] = useState(false);
    useEffect(() => {
        setCurrentPage(1);
    }, [valor.value.tablasva, itemsPerPage]);

    useEffect(() => {
        setTableItems(valor.value.tablasva);

        if (valor.value.tablasva.length > 0) {
            setCurrentItems(valor.value.tablasva.slice(indexOfFirstItem, indexOfLastItem));
        } else {
            setCurrentItems([]);
        }
    }, [valor, indexOfFirstItem, indexOfLastItem]);
    useEffect(() => {
        if (tableItems !== undefined) {
            setCurrentItems(tableItems.slice(indexOfFirstItem, indexOfLastItem));
        }
    }, [tableItems, indexOfFirstItem, indexOfLastItem]);

    const lastPage = Math.max(Math.ceil(Object.values(tableItems).length / itemsPerPage), 1);
    const paginate = (pageNumber) => {
        if (typeof pageNumber === "number") {
            setCurrentPage(pageNumber);
        } else {
            console.log(pageNumber);
        }
    }
    const nextPaginate = (pageNumber) => {
        if (pageNumber === lastPage) {
            setCurrentPage(pageNumber);
        } else {
            setCurrentPage(pageNumber + 1);
        }
    }
    const backPaginate = (pageNumber) => {
        if (pageNumber === 1) {
            setCurrentPage(pageNumber);
        } else {
            setCurrentPage(pageNumber - 1);
        }
    }
    const pageNumbers = [];
    if (tableItems !== undefined) {
        for (let i = 1; i <= Math.ceil(tableItems.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }
    }
    let tempNumberOfPages = [...pageNumbers];

    let dotsInitial = '...';
    let dotsLeft = '... ';
    let dotsRight = ' ...';
    let dotsEnd = ' ... ';

    if (pageNumbers.length <= 5) {
        tempNumberOfPages = pageNumbers;
    } else if (currentPage >= 1 && currentPage <= 3) {
        tempNumberOfPages = [1, 2, 3, 4, dotsInitial, pageNumbers.length];
    } else if (currentPage === 4) {
        const sliced = pageNumbers.slice(0, 5)
        tempNumberOfPages = [...sliced, dotsInitial, pageNumbers.length];
    } else if (currentPage > 4 && currentPage < pageNumbers.length - 2) {
        const sliced1 = pageNumbers.slice(currentPage - 2, currentPage);
        const sliced2 = pageNumbers.slice(currentPage, currentPage + 1);
        tempNumberOfPages = [1, dotsLeft, ...sliced1, ...sliced2, dotsRight, pageNumbers.length];
    } else if (currentPage > pageNumbers.length - 3 && pageNumbers.length !== 0) {
        const sliced = pageNumbers.slice(pageNumbers.length - 4);
        tempNumberOfPages = [1, dotsEnd, ...sliced];
    } else if (pageNumbers.length === 0) {
        tempNumberOfPages = [];
    }

    const sliderRestrictionBack = () => {
        if (currentPage === 1) {
            return 'disable';
        }
    }
    const sliderRestrictionNext = () => {
        if (currentPage === lastPage) {
            return 'disable';
        }
    };
    const activePaginate = (pageNumber) => {
        if (currentPage === pageNumber) {
            return "active";
        }
    }
    const showPageControls = pageNumbers.length > 1;

    useEffect(() => {
        const closeRowsMenu = (event) => {
            if (event.target.tagName !== 'svg') {
                setIpp(false);
            }
        };
        document.body.addEventListener('click', closeRowsMenu)
        return () => document.body.removeEventListener('click', closeRowsMenu)
    }, [])
    return (
        <div className="soltable">
            <div className="responsiveFix">
                <div className="responsiveAuto">
                    <ul>
                        <li className='listHeader listItem'>{`Cliente`}</li>
                        <li className='listHeader listItem'>{`Ciudad`} </li>
                        <li className='listHeader listItem'>{`Estado firma`}</li>
                        <li className='listHeader listItem'>{solicTableLabels.creditStatus}</li>
                        <li className='listHeader listItem'>{`Monto`}</li>
                        <li className='listHeader listItem'>{solicTableLabels.creditLine}</li>
                        <li className='listHeader listItem'>{`Fecha de solicitud`}</li>
                        <li className='listHeader listItem'>{`Acciones`}</li>
                    </ul>
                    {
                        currentItems.map((info, i) => {
                            return (
                                <SolicItem key={i} info={{info}}/>
                            )
                        })
                    }
                    {currentItems.length === 0 && (
                        <div className="solic-empty-state">{solicTableLabels.empty}</div>
                    )}
                </div>
            </div>
            <div className="pagination">
                <ul className="itemsPerPage">
                    <p>{solicTableLabels.rowsPerPage}</p>
                    <ul>
                        <p style={{margin: "0px"}}>{itemsPerPage}</p>
                        <ul className={ipp ? `open` : `close`}>
                            <li><p onClick={() => setItemsPerPage(10)}>10</p></li>
                            <li><p onClick={() => setItemsPerPage(50)}>50</p></li>
                            <li><p onClick={() => setItemsPerPage(100)}>100</p></li>
                        </ul>
                    </ul>
                    <span onClick={() => {
                        setIpp(!ipp);
                    }} style={{cursor: 'pointer', marginTop: '0px'}}><VscChevronDown/></span>
                </ul>
                {showPageControls && (
                    <ul className="pageNum">
                        <li onClick={() => backPaginate(currentPage)} className={`paginate-item back ${sliderRestrictionBack()}`}><VscChevronLeft/> </li>
                        {
                            tempNumberOfPages.map((number, i) => {
                                return (
                                    <li onClick={() => paginate(number)} key={i} className={`paginate-item paginate-number ${activePaginate(number)}`}>
                                        {number}
                                    </li>
                                )
                            })
                        }
                        <li onClick={() => nextPaginate(currentPage)} className={`paginate-item next ${sliderRestrictionNext()}`}><VscChevronRight/> </li>
                    </ul>
                )}
            </div>
        </div>
    )
}
